import { Helmet } from 'react-helmet';

// Declare the global 'ml' property on the window object to avoid implicit 'any' type errors
declare global {
  interface Window {
    ml: any; // You can refine this type further if needed
  }
}

const SignupForm = () => {

  return (
    <>
    <Helmet>
      <script>
          {`(function(w,d,e,u,f,l,n){w[f]=w[f]||function(){(w[f].q=w[f].q||[])
          .push(arguments);},l=d.createElement(e),l.async=1,l.src=u,
          n=d.getElementsByTagName(e)[0],n.parentNode.insertBefore(l,n);})
          (window,document,'script','https://assets.mailerlite.com/js/universal.js','ml');
          ml('account', '1526072');`}
      </script>
    </Helmet>
    <div className="ml-embedded" data-form="HA1VtP" style={{backgroundColor:'#f6f6f600'}}></div>
  </>
  );
};

export default SignupForm;
